import { API_URL } from "../../config/connect";

const ALLOWED_EXTENSIONS = [".xlsx", ".csv", ".tsv"];

/**
 * POST /api/v1/announcements/bulk-upload — multipart/form-data, field name: `file`.
 * @param {File} file - .xlsx, .csv or .tsv (client should enforce size/row limits per API)
 * @param {string} accessToken - Bearer JWT
 * @returns {Promise<{ created_count: number, error_count: number, created: Array<{row: number, announcement_id: number}>, errors: Array<{row: number, error: string}> }>}
 */
export async function bulkUploadAnnouncements(file, accessToken) {
    if (!file) {
        throw new Error("No file selected");
    }
    const ext = "." + (file.name.split(".").pop() || "").toLowerCase();
    if (!ALLOWED_EXTENSIONS.includes(ext)) {
        throw new Error("Allowed formats: .xlsx, .csv, .tsv");
    }

    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${API_URL}/api/v1/announcements/bulk-upload`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
    });

    if (!response.ok) {
        const text = await response.text();
        let message = text;
        try {
            const json = JSON.parse(text);
            message = json.message || json.error || json.detail || text;
        } catch (_) {}
        throw new Error(message || `Error: ${response.status}`);
    }

    return response.json();
}
